module.exports = __webpack_public_path__ + "static/media/meta_lay.9ff42c5e.svg";